var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 20,
    viewBox: "0 0 26 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.254 11.188L7.254 16.38C7.25611 17.1241 7.55263 17.8371 8.07878 18.3632C8.60492 18.8894 9.31792 19.1859 10.062 19.188H15.678C16.4221 19.1859 17.1351 18.8894 17.6612 18.3632C18.1874 17.8371 18.4839 17.1241 18.486 16.38V11.188L25.74 -1.14441e-05H0L7.254 11.188ZM9.126 16.38V11.7H16.614V16.38C16.6132 16.628 16.5143 16.8656 16.339 17.041C16.1636 17.2163 15.926 17.3152 15.678 17.316H10.062C9.814 17.3152 9.57638 17.2163 9.40102 17.041C9.22566 16.8656 9.12679 16.628 9.126 16.38ZM17.126 9.82799L8.611 9.82799L3.463 1.87199H22.276L17.126 9.82799Z",
    fill: "#B5B5B5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.2887d1345fc8b0b42abac105d87ead1a.svg";
export { ForwardRef as ReactComponent };